<template>
    <div id="yield-page">
        <GenericPage>
            <template slot="breadcrumb-items">
                <li class="active bold">Rendimiento</li>
            </template>
            <template slot="title">
                Rendimientos <span class="bold">estables</span>
                y <span class="bold">competitivos.</span>
            </template>
            <template slot="body">
                <Yield v-if="rgStats != null" :rgStats="rgStats" :isMounted="rgStats != null"/>
                <Payments v-if="rgStats != null" :rgStats="rgStats" :isMounted="rgStats != null" />
                <Funding v-if="rgStats != null" :rgStats="rgStats" :isMounted="rgStats != null"/>
            </template>
        </GenericPage>
    </div>
</template>
    
<script>
import sal from 'sal.js';
import GenericPage from './GenericPage.vue';
import Yield from '@components/landing-components/for-yield-page/Yield.vue';
import Payments from '@components/landing-components/for-yield-page/Payments.vue';
import Funding from '../../components/landing-components/for-yield-page/Funding.vue';
export default {
    name: "YieldPage",
    components: {
        GenericPage,
        Yield,
        Payments,
        Funding
    },
    data() {
        return {
            rgStats: null,
            isMounted: false
        }
    },
    async mounted() {
        await sal();
        await this.RgStats();
    },
    methods: {
        async RgStats() {
            this.isMounted = false;
            this.rgStats = await this.setRgStatsData();
            this.isMounted = true;
            this.$forceUpdate();
        }
    }
}
</script>
    
<style scoped></style>